import * as React from 'react';
import { ISectionProps, sectionFactory } from '../SectionFactory';

export const GridContainer = sectionFactory('containerv2')
export const FlexRow = sectionFactory('flex-row')

interface IFlexColumnProps extends ISectionProps {
  columns?: 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
}

export class FlexColumn extends React.Component<IFlexColumnProps, {}> {

  render() {
    let className = 'flex-col'

    if (this.props.columns) {
      className += `-${this.props.columns}`
    }

    return sectionFactory(className)(this.props)
  }
}
